<template lang="pug">
.goods-list
  list-search(@onSearch="onSearch" @onExport="onExport" ref="search-form")
  .tabs-container
    .link( @click="setDiscount") 针对不同用户设置价格优惠？前往会员权益设置 》
    el-tabs(v-model="searchData['status']" @tab-click="changeTab")
      el-tab-pane(v-for="item, index in goodsTabs" :key="index" :name="item.name" :label="item.label")
        .mb-15(v-if="searchData.status !== '1'")
          el-button.bgc-f(type="danger" plain :disabled="itemIds.length === 0" size="mini" @click="updatePrice('batch')") 批量改价
          el-button.bgc-f(type="danger" plain :disabled="itemIds.length === 0" size="mini"
            v-if="searchData.status === '3'"  @click="goodsBatchOperate(2, '上架')")  批量上架
          el-button.bgc-f(type="danger" plain :disabled="itemIds.length === 0" size="mini"
            v-if="searchData.status === '2'" @click="goodsBatchOperate(3, '下架')" )  批量下架
          el-button.bgc-f(type="danger" plain :disabled="itemIds.length === 0" size="mini"
            v-if="searchData.status !== '1'" @click="isShowUpdateSubTitle = true" )  批量修改副标题
          el-button.bgc-f(type="danger" plain :disabled="itemIds.length === 0" size="mini"
            v-if="searchData.status=== '3'" @click="goodsBatchOperate(4, '删除')") 批量删除
          el-button.bgc-f(type="danger" plain size="mini" @click="updatePrice('all')"
            :disabled="itemIds.length > 0" v-if="isShowAllBtn")  全部改价
          el-button.bgc-f(type="danger" plain v-if="searchData.status === '3' && isShowAllBtn"
            @click="goodsAllOperate(2, '上架')" :disabled="itemIds.length > 0" size="mini")  全部上架
          el-button.bgc-f(type="danger" plain v-if="searchData.status === '2' && isShowAllBtn"
            @click="goodsAllOperate(3, '下架')" :disabled="itemIds.length > 0" size="mini")  全部下架
          el-button.bgc-f(type="danger" plain v-if="searchData.status === '2'"
            @click="$refs['search-form'] && $refs['search-form'].onExport()" size="mini")  导出
          el-button.bgc-f(type="danger" plain v-if="searchData.status === '2'"
            @click="addShareList" :disabled="itemIds.length === 0" size="mini")  添加到资源单
          el-button.bgc-f(type="danger" plain v-if="searchData.status === '2'"
            @click="batchShareList" :disabled="itemIds.length === 0" size="mini")  生成资源单

  el-table.table(:data="goodsList" style="width: 99.9%" @selection-change="handleCheck" ref="goodsTable"
    :header-cell-style="{'font-size': '12px', background: '#f2f2f2', color: '#333'}"
    :class="{'table-two': searchData.status !== '1'}" @sort-change="specSortHandler")

    el-table-column(type="selection" label="全选" width="55" v-if="searchData.status !== '1'")

    el-table-column(label="商品" align="left" min-width="140px" sortable="custom" )
      template(slot-scope="scope")
        .goods-name(@click="toMallDetaill(scope.row.id)") {{scope.row.title}}
        .goods-no.font-12(@click="toMallDetaill(scope.row.id)") 商品编号：{{scope.row.id}}
        .goods-no.font-12(v-if="scope.row.warehouseVO" @click="toMallDetaill(scope.row.id)") {{scope.row.warehouseVO.nameAbbr}}({{scope.row.warehouseVO.city}})
        el-tooltip(:content="scope.row.itemExtInfoVO && scope.row.itemExtInfoVO.supplierName" placement="bottom" v-if="scope.row.itemExtInfoVO && scope.row.itemExtInfoVO.supplierName")
          .goods-no.font-12.row-ellipsis {{ scope.row.itemExtInfoVO.supplierName }}
        .indefinite(v-if="scope.row.itemExtInfoVO.subItemType === 'UNCERTAIN'") 不定规格
        .indefinite(v-if="scope.row.itemExtInfoVO.isFutureItem") 预售

    el-table-column(label="捆包号" prop="minPriceItemSkuVO.packageNo" align="center")

    el-table-column(label="单件重" align="center")
      template(slot-scope="scope")
        div(v-if="scope.row.minPriceItemSkuVO && scope.row.itemExtInfoVO.subItemType === 'NORMAL'")
          span {{scope.row.minPriceItemSkuVO.amountPerUnit / 10000}}
          span {{getWeightUnit(scope.row.itemExtInfoVO.valuationUnitValue)}}
        div(v-if="scope.row.itemExtInfoVO.subItemType === 'UNCERTAIN'")
          span {{scope.row.itemExtInfoVO.amountPerUnit / 10000}}
          span {{getWeightUnit(scope.row.itemExtInfoVO.valuationUnitValue)}}

    el-table-column(label="单价" align="center")
      template(slot-scope="scope")
        .flex.flex-ac.flex-c
          .sku-price(v-if="scope.row.minPriceItemSkuVO && scope.row.itemExtInfoVO.subItemType === 'NORMAL'")
            | {{scope.row.minPriceItemSkuVO.price / 100}}元/{{getGoodsUnit(scope.row.itemExtInfoVO.valuationUnitValue)}}
          .sku-price(v-if="scope.row.itemExtInfoVO.subItemType === 'UNCERTAIN'")
            | {{scope.row.marketPrice / 100}}元/{{getGoodsUnit(scope.row.itemExtInfoVO.valuationUnitValue)}}
          svg-icon.m-l5.edit-icon(icon-class="edit" @click.native="showEditDialog(scope.row)")
        .sku-total.font-12(v-if="scope.row.itemExtInfoVO.subItemType === 'NORMAL'")
          | 共{{scope.row.skuList && scope.row.skuList.length}}件
    el-table-column(label="会员价" align="center")
      template(slot-scope="scope")
        .sku-price {{scope.row.itemExtInfoVO.itemMemberVO.minMemberPrice / 100}}元/{{getGoodsUnit(scope.row.itemExtInfoVO.valuationUnitValue)}}
    el-table-column(label="库存数量" align="center" prop="minPriceItemSkuVO.stockNum")
      template(slot-scope="scope")
        span(v-if="scope.row.itemExtInfoVO.subItemType === 'NORMAL'") {{scope.row.minPriceItemSkuVO.stockNum}}
        span(v-if="scope.row.itemExtInfoVO.subItemType === 'UNCERTAIN'") {{scope.row.stockNum}}
    el-table-column(label="在售状态" align="center")
      template(slot-scope="scope")
        span.font-12(v-if="scope.row.status === 'CREATE' || scope.row.status === 'INVALID'") 待上架
        span.font-12(v-if="scope.row.status === 'VALID'") 上架中
    el-table-column(label="创建人" prop="itemExtInfoVO.createUser" align="center")
    el-table-column(label="更新人" prop="itemExtInfoVO.operateUser" align="center")

    el-table-column(label="操作" width="100px" class-name="operate")
      template(slot-scope="scope")
        el-button.btn-text(type="text" @click="$router.push(`detail/${scope.row.id}`)") 详情
        el-button.btn-text(type="text" @click="$router.push(`update/${scope.row.id}`)") 编辑
        el-button.btn-text(type="text" @click="goodsOperate(scope.row.id, 2, '上架')"
          v-if="scope.row.status === 'CREATE' || scope.row.status === 'INVALID'") 上架
        el-button.btn-text(type="text" @click="goodsOperate(scope.row.id, 3, '下架')"
          v-if="scope.row.status === 'VALID'") 下架
        el-button.btn-text(type="text" @click="goodsOperate(scope.row.id, 4, '删除')"
          v-if="scope.row.status === 'CREATE' || scope.row.status === 'INVALID'") 删除
        el-button.btn-text(type="text" @click="toogleExpand(scope.row, 'cutout')"
          v-if="scope.row.skuList && scope.row.skuList.length > 1 && !scope.row.isShowAll") 展开
        el-button.btn-text(type="text" @click="toogleExpand(scope.row)" v-if="scope.row.isShowAll") 收起

    el-table-column(type="expand" width="1")
      template(slot-scope="scope")
        el-table.inner-table(:data="scope.row.skuList" style="width: 99.9%" :show-header="false")
          el-table-column(label="全选" width="55" v-if="searchData.status !== '1'")
          el-table-column(label="商品" align="left" min-width="140px")
          el-table-column(label="捆包号" prop="" align="center")
            template(slot-scope="skuscope")
              p(v-if="scope.row.minPriceItemSkuVO && scope.row.minPriceItemSkuVO.id !== skuscope.row.id")
                | {{skuscope.row.packageNo}}
          el-table-column(label="单件重" align="center" prop="amountPerUnit")
            template(slot-scope="skuscope")
              p(v-if="scope.row.minPriceItemSkuVO && scope.row.minPriceItemSkuVO.id !== skuscope.row.id")
               | {{skuscope.row.amountPerUnit / 10000}}{{getWeightUnit(scope.row.itemExtInfoVO.valuationUnitValue)}}
          el-table-column(label="单价" align="center")
            template(slot-scope="skuscope")
              .sku-price(v-if="scope.row.minPriceItemSkuVO && scope.row.minPriceItemSkuVO.id !== skuscope.row.id")
                | {{skuscope.row.price / 100}} 元/{{getGoodsUnit(scope.row.itemExtInfoVO.valuationUnitValue)}}
          el-table-column(label="会员价" align="center")
            template(slot-scope="skuscope")
              .sku-price( v-if="scope.row.minPriceItemSkuVO && scope.row.minPriceItemSkuVO.id !== skuscope.row.id")
                | {{skuscope.row.memberPrice / 100}}元/{{getGoodsUnit(scope.row.itemExtInfoVO.valuationUnitValue)}}
          el-table-column(label="库存数量" align="center")
            template(slot-scope="skuscope")
              p(v-if="scope.row.minPriceItemSkuVO && scope.row.minPriceItemSkuVO.id !== skuscope.row.id")
                | {{skuscope.row.stockNum}}
          el-table-column(label="在售状态" align="center")
          el-table-column(label="创建人" align="center")
          el-table-column(label="更新人" align="center")
          el-table-column(label="操作" width="100px" align="center" class-name="operate")

  el-pagination.pagination(background :page-size="searchData.pageSize" v-if="listCount > 0"
    :page-sizes="[20, 40, 80, 120]" @size-change="handleSizeChange"
    :current-page="searchData.pageNo" layout="total, sizes, prev, pager, next, jumper" prev-text="上一页"
    :total="listCount" @current-change="getItemList" next-text="下一页")

  el-dialog(title="修改商品价格" :visible.sync="isShowUpdatePrice" center)
    el-form(label-width="100px")
      el-form-item(label="调价类型：" :rules="[ { required: true } ]")
        el-radio-group(v-model="adjustPriceType")
          el-radio(:label="1") 调高
          el-radio(:label="2") 调低
          el-radio(:label="3") 统一定价
      el-form-item(label="调价幅度：" :rules="[ { required: true } ]")
        el-input(v-model="price" @input="only2Decimal" placeholder="请输入价格")
      el-form-item(label="提示：")
        .tips 修改{{updatePriceType === 'all' ? `全部${listCount}` : `全部${itemIds.length}`}}条商品价格
    .dialog-footer(slot="footer")
      el-button(@click="isShowUpdatePrice = false") 取 消
      el-button(type="primary" @click="confirmUpdateDialog(2)") 确认上架
      el-button(type="primary" @click="confirmUpdateDialog(3)") 暂存待售

  el-dialog(title="修改商品副标题" :visible.sync="isShowUpdateSubTitle" center)
    el-form(label-width="120px")
      el-form-item(label="商品副标题：" :rules="[ { required: true } ]")
        el-input(v-model="subTitle" maxlenght="30" placeholder="请输入商品副标题")
        .tips 支持输入空格，将副标题批量清空
    .dialog-footer(slot="footer")
      el-button(@click="isShowUpdateSubTitle = false; subTitle = ''") 取 消
      el-button(type="primary" @click="confirmUpdateSubTitle") 确 认

  quotation-dialog(v-model="isShowDialog" :data="quotations" type="text" :warehouses="warehouses")

  price-edit-dialog(:goodsItem="currentEditGoods" @confirm="onEditConfirm" :visible.sync="isShowEditDialog")

</template>

<script>
import { ZM_ROOT } from '@/common/constants/'
import { validNumber } from '@/common/utils/validate.js'
import ListSearch from './components/listSearch'
import QuotationDialog from './components/quotation.vue'
import PriceEditDialog from './components/goodsSkuPriceEditDialog.vue'
import NP from 'number-precision'
import { Tooltip } from '@zg/element-ui'
import { download } from '@/common/utils/download'

export default {
  name: 'goodsList',
  data() {
    return {
      goodsList: [],
      listCount: 0,
      searchData: {
        status: '1',
        pageNo: 1,
        pageSize: 80,
        sortType: 'GMT_CREATED_DESC',
        itemTypes: ['STEELS'],
        transportTemplateId: 0
      },
      goodsTabs: [
        {
          name: '1',
          label: '全部'
        },
        {
          name: '2',
          label: '出售中'
        },
        {
          name: '3',
          label: '待出售'
        }
      ],
      itemIds: [],
      isShowUpdatePrice: false,
      adjustPriceType: 1,
      price: '',
      updatePriceType: '',
      isShowAllBtn: true,
      isShowUpdateSubTitle: false,
      subTitle: '',
      warehouses: [],
      quotations: [],
      isShowDialog: false,
      currentEditGoods: {},
      isShowEditDialog: false,
      exportPriceType: 2,
      activeTab: ''
    }
  },
  components: {
    ListSearch,
    QuotationDialog,
    PriceEditDialog,
    [Tooltip.name]: Tooltip
  },
  mounted() {
    this.handleUrlQuery()
    this.getItemList()
    this.catchExportConfig()
  },
  activated() {
    this.handleUrlQuery()
    this.catchExportConfig()
  },
  methods: {
    async catchExportConfig() {
      const result = await this.$get('items.getShareConfig')
      if (result.success) {
        const { value = 1 } = result.data[0]
        this.exportPriceType = value
      }
    },
    showEditDialog(item) {
      this.currentEditGoods = item
      this.isShowEditDialog = true
    },
    async onEditConfirm(item) {
      let param
      const { id = 0, price = 0, skuList = [] } = item
      if (skuList && skuList.length > 0) {
        param = {
          itemId: id,
          itemSkuVOList: skuList.map(item => ({
            id: item.id,
            price: NP.times(item.price, 100)
          }))
        }
      } else {
        param = {
          itemId: id,
          price: NP.times(price, 100)
        }
      }
      try {
        const result = await this.$post('items.editItemSkuPrice', { itemSkuPriceEditVO: param })
        if (result.success) {
          const { value = false } = result.data[0]
          if (value) {
            this.$message.success('价格修改成功')
            this.$refs['search-form'] && this.$refs['search-form'].onSearch()
          } else {
            this.$message.error('价格修改失败')
          }
        }
      } catch (e) {
        e
      }
    },
    setDiscount() {
      this.$router.push('/shop/member/equity/list')
    },
    /** 复选框 */
    handleCheck(vals) {
      this.itemIds = []
      vals &&
        vals.forEach(item => {
          this.itemIds.push(item.id)
        })
    },
    toogleExpand(row, type) {
      this.$refs.goodsTable.toggleRowExpansion(row)
      row.isShowAll = type === 'cutout'
    },
    /** 查询 */
    onSearch(data) {
      if (!data.sortType) {
        data.sortType = 'GMT_CREATED_DESC'
        this.$refs.goodsTable.clearSort()
      }
      this.searchData = Object.assign(this.searchData, data)
      if (validNumber(this.searchData.itemId)) {
        this.getItemList()
      } else {
        this.$message.warning('请输入正确的商品编号!')
        return false
      }
    },
    onExport(data) {
      if (!data.sortType) {
        data.sortType = 'GMT_CREATED_DESC'
        this.$refs.goodsTable.clearSort()
      }
      this.searchData = Object.assign(this.searchData, data)
      if (validNumber(this.searchData.itemId)) {
        this.exportExcel()
      } else {
        this.$message.warning('请输入正确的商品编号!')
        return false
      }
    },
    async exportExcel() {
      try {
        const result = await this.$get('items.getItemsExportKey', {
          queryItemDTO: this.searchData
        })
        if (result.success) {
          const { value = '' } = result.data[0]
          if (value) {
            download(value)
          } else {
            this.$message.error('记录不存在，无法导出')
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 获取商品列表 */
    async getItemList(page) {
      this.itemIds = []
      this.searchData.pageNo = page || 1
      try {
        const result = await this.$get('items.getItemsForSeller', {
          queryItemDTO: this.searchData
        })
        if (result.success) {
          this.isShowAllBtn = !this.searchData.title && !this.searchData.itemId
          this.goodsList = result.data[0].list || []
          this.goodsList.forEach((item, index) => {
            item.hasMore = item.skuList && item.skuList.length > 1
            if (!item.minPriceItemSkuVO) {
              item.minPriceItemSkuVO = (item.skuList && item.skuList[0]) || {}
            }
          })
          this.listCount = result.data[0].recordCount
          this.getSaledGoods()
        }
      } catch (err) {
        console.log(err)
      }
    },
    async getSaledGoods() {
      try {
        const result = await this.$post('items.getItemsForSeller', {
          queryItemDTO: Object.assign({}, this.searchData, {
            pageNo: 1,
            status: this.searchData.status !== '1' ? '1' : '2'
          })
        })
        this.searchData.status === '2'
          ? (this.goodsTotal = result.data[0].recordCount)
          : (this.saleGoodsTotal = result.data[0].recordCount)
        let goodsTotal =
          this.searchData.status !== '1' ? result.data[0].recordCount : this.listCount
        let saleGoodsTotal =
          this.searchData.status === '1'
            ? result.data[0].recordCount
            : this.searchData.status === '2'
            ? this.listCount
            : result.data[0].recordCount - this.listCount
        this.goodsTabs[0].label = `全部 (${goodsTotal})`
        this.goodsTabs[1].label = `出售中 (${saleGoodsTotal})`
        this.goodsTabs[2].label = `待出售 (${goodsTotal - saleGoodsTotal})`
      } catch (err) {
        console.log(err)
      }
    },
    /** 表格合并 */
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        return [1, 4]
      } else if (columnIndex === 4 || columnIndex === 5 || columnIndex === 6) {
        return [0, 0]
      }
    },
    /** 商品操作 operate, 2上架，3下架，4删除 */
    goodsOperate(itemId, operate, operateText) {
      this.$confirm(`您确定要${operateText}此商品吗?`, '提示', {
        center: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      })
        .then(async () => {
          try {
            const result = await this.$post('items.operate', {
              itemOperateDTO: {
                itemId,
                operate
              }
            })
            if (result.success) {
              if (result.data[0] && result.data[0].value) {
                this.getItemList()
                this.$message.success(`商品${operateText}操作成功`)
              } else {
                this.$message.error(`商品${operateText}操作失败`)
              }
            }
          } catch (err) {
            console.log(err)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /** 商品全部操作 operate, 2上架，3下架，4删除 */
    goodsAllOperate(operate, operateText) {
      this.$confirm(`您确定要${operateText}全部商品吗?`, '提示', {
        center: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      })
        .then(async () => {
          try {
            const result = await this.$post('items.batchAllOperate', {
              itemAllOperateDto: {
                orgId: this.$store.state.user.userCurrentOrg.id,
                operate,
                tabType: Number(this.searchData.status)
              }
            })
            if (result.success) {
              if (result.data[0] && result.data[0].value) {
                this.$message.success('操作成功')
                this.getItemList()
              } else {
                this.$message.error(`商品${operateText}操作失败`)
              }
            }
          } catch (err) {
            console.log(err)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /** 商品批量操作 operate, 2上架，3下架，4删除 */
    goodsBatchOperate(operate, operateText) {
      this.$confirm(`您确定要${operateText}选中商品吗?`, '提示', {
        center: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      })
        .then(async () => {
          try {
            const result = await this.$post('items.batchOperate', {
              itemBatchOperateQuery: {
                orgId: this.$store.state.user.userCurrentOrg.id,
                itemIdList: this.itemIds,
                operate
              }
            })
            if (result.success) {
              if (result.data[0] && result.data[0].value) {
                this.$message.success('操作成功')
                this.getItemList()
              } else {
                this.$message.error(`商品${operateText}操作失败`)
              }
            }
          } catch (err) {
            console.log(err)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /** 商品批量修改副标题 */
    confirmUpdateSubTitle() {
      this.$confirm(`您确定要修改选中商品副标题吗?`, '提示', {
        center: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      })
        .then(async () => {
          try {
            const result = await this.$post('items.batchSubTitleOperate', {
              itemSubTitleDTO: {
                orgId: this.$store.state.user.userCurrentOrg.id,
                itemIdList: this.itemIds,
                subTitle: this.subTitle
              }
            })
            if (result.success) {
              if (result.data[0] && result.data[0].value) {
                this.$message.success('操作成功')
                this.isShowUpdateSubTitle = false
                this.subTitle = ''
              } else {
                this.$message.error(`修改选中商品副标题失败`)
              }
            }
          } catch (err) {
            console.log(err)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /** 只能有两位 */
    only2Decimal() {
      try {
        this.price = this.price.replace(/[^\d.]/g, '')
        this.price = this.price.replace(/^\./g, '')
        this.price = this.price.replace(/\.{2,}/g, '.')
        this.price = this.price
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.')
        this.price = this.price.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
      } catch (e) {
        this.price = 0
      }
    },
    /** 显示修改商品价格弹窗 */
    updatePrice(type) {
      this.updatePriceType = type
      this.isShowUpdatePrice = true
      this.adjustPriceType = 1
      this.price = ''
    },
    /** 确认修改商品价格 */
    confirmUpdateDialog(operateType) {
      if (!this.price) {
        return this.$message.error('请输入价格')
      }
      this.$confirm(
        `您确定要修改选中${this.updatePriceType === 'all' ? '全部' : '选中'}商品吗?`,
        '提示',
        {
          center: true,
          confirmButtonText: '确认',
          cancelButtonText: '取消'
        }
      )
        .then(async () => {
          try {
            let result = ''
            if (this.updatePriceType === 'all') {
              result = await this.$post('items.batchAllModifyPrice', {
                itemAllModifyPriceDto: {
                  price: this.price * 100,
                  adjustPriceType: this.adjustPriceType,
                  operateType,
                  orgId: this.$store.state.user.userCurrentOrg.id,
                  tabType: Number(this.searchData.status)
                }
              })
            }
            if (this.updatePriceType === 'batch') {
              result = await this.$post('items.batchModifyPrice', {
                itemBatchModifyPriceDto: {
                  adjustPriceType: this.adjustPriceType,
                  operateType,
                  price: this.price * 100,
                  orgId: this.$store.state.user.userCurrentOrg.id,
                  itemIds: this.itemIds
                }
              })
            }
            if (result.success) {
              if (result.data[0] && result.data[0].value) {
                this.$message.success('商品价格修改成功')
                this.isShowUpdatePrice = false
                this.getItemList(this.updatePriceType === 'all' ? 1 : this.searchData.pageNo)
              } else {
                this.$message.error(`商品价格修改失败`)
              }
            }
          } catch (err) {
            console.log(err)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /** 修改tab */
    changeTab(item, evt) {
      if (!this.activeTab || this.activeTab !== item.name) {
        this.activeTab = item.name
        this.getItemList()
      }
    },
    /** 修改pageSzie */
    handleSizeChange(val) {
      this.searchData.pageSize = val
      this.getItemList()
    },
    getWeightUnit(type) {
      let out = '吨'
      if (type === 'KG') {
        out = '千克'
      }
      return out
    },
    toMallDetaill(id) {
      window.open(`${ZM_ROOT}/goods/${id}`)
    },
    getGoodsUnit(type) {
      let unit = {
        TON: '吨',
        KG: '千克',
        SHEET: '张',
        ROOT: '根',
        PIECE: '件',
        AN: '个'
      }
      return unit[type]
    },
    // 处理 url 的 query（方便其他页面带入查询条件）
    handleUrlQuery() {
      const { transportTemplateId, type, page } = this.$route.query
      if (transportTemplateId) {
        this.searchData.transportTemplateId = transportTemplateId * 1
      }
      if (type === 'refresh') {
        if (page === 'current') {
          this.getItemList(this.searchData.pageNo)
        } else {
          this.getItemList()
        }
        // 查询后删除 query，防止切换 tab 再次触发生命周期 activated
        this.$router.replace({ query: null })
      }
    },
    /** 添加资源单 */
    async addShareList() {
      if (!this.itemIds || this.itemIds.length === 0) return this.$message.error('请选择商品')
      try {
        const { data = [] } = await this.$post('items.seller.addShareList', {
          querySharesDTO: {
            itemIds: this.itemIds
          }
        })
        if (data[0]) {
          if (data[0].value) {
            this.$message.success('操作成功')
            this.$refs.goodsTable && this.$refs.goodsTable.clearSelection()
            this.$store.dispatch('quotation/getCount')
          } else {
            this.$message.error('操作失败')
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 批量分享 */
    async batchShareList() {
      if (!this.itemIds || this.itemIds.length === 0) return this.$message.error('请选择商品')
      try {
        const { data = [] } = await this.$post('items.seller.getAndAddSharesByUserShop', {
          querySharesDTO: {
            itemIds: this.itemIds
          }
        })
        if (data[0]) {
          this.$refs.goodsTable && this.$refs.goodsTable.clearSelection()
          this.quotations =
            this.exportPriceType === 1
              ? data[0].partVOS
              : data[0].partVOS.map(kind => ({
                  ...kind,
                  shareItemVOS: kind.shareItemVOS.map(item => ({
                    ...item,
                    price: item.memberPrice
                  }))
                }))
          this.warehouses = data[0].warehoseVOS
          this.isShowDialog = true
        }
      } catch (err) {
        console.log(err)
      }
    },
    async specSortHandler({ column: { label = '' } = {}, order = '' }) {
      let keyword = 'GMT_CREATED_DESC'
      if (label === '商品') {
        switch (order) {
          case 'ascending': {
            keyword = 'SPECIFICATION_ASC'
            break
          }
          case 'descending':
            keyword = 'SPECIFICATION_DESC'
            break
        }
      }
      this.$refs['search-form'].onSearch(keyword ? { sortType: keyword } : {})
    }
  }
}
</script>

<style lang="stylus" scoped>
.goods-list
  .tabs-container
    position relative
    .link
      position absolute
      right 0
      top 0
      line-height 40px
      color: #cd974c;
      cursor pointer
      z-index 1
    /deep/ .el-tabs__nav-wrap
      padding-right 360px
  .bgc-f
    background #fff
    background-color #fff
    &:focus
      color #ff4949
    &:hover
      color #fff
      background-color #ff4949
  .tip
    height 25px
    line-height 25px
    font-size 12px
    color #9e9e9e

  .mb-15
    margin-bottom 15px

  .ml-20
    margin-left 20px

  .goods-name
    width 100%
    line-height 1.4
    white-space normal
    overflow hidden
    text-overflow ellipsis
    display -webkit-box
    -webkit-line-clamp 2
    -webkit-box-orient vertical
    font-size 13px
    color #000
    cursor pointer

  .font-12
    font-size 12px

  .sku-total
    color #666

  .sku-price
    color #333
    font-weight 500
    font-size 13px

  .btn-text
    padding 0 5px !important
    font-size 12px

  /deep/.table
    th, td
      padding 2px 0
      font-size 13px
    .el-table__expanded-cell
      border-bottom 0
    .expanded
      td
        &:first-child
          border-bottom 0

    .el-checkbox
      text-align left
      margin-left 10px

  /deep/.table-two
    .expanded
      td
        &:nth-child(2)
          border-bottom 0

  .goods-no
    line-height 1.4
    cursor pointer

  /deep/.el-date-editor.el-input
    width 165px

  .sku-list
    margin-left -10px
    width calc(100% + 20px)

    li
      display flex
      padding 6px 0
      border-bottom 1px solid #EBEEF5
      justify-content center

      &:last-child
        border-bottom none

      .item
        flex 1
        text-align center
        white-space pre-line
        line-height 1

      .has-more
        font-size 12px
        padding 0

  /deep/.operate
    .cell
      line-height 18px
      .el-button--text
        padding 5px
      .el-button+.el-button
        margin-left 0

  /deep/.inner-table
    td
      border-bottom 0
.indefinite
  & + .indefinite
    margin-left 10px
  display inline-block
  padding 0 5px
  background rgba(248,248,248,1)
  border-radius 1px
  border 1px solid rgba(237,201,201,1)
  color rgba(208,17,26,1)
  font-size 10px
  height 12px
  line-height 12px
  margin 3px 0
.tips
  font-size 14px
  margin-top 20px
  color #999999
.edit-icon
  cursor pointer
.row-ellipsis
  word-break break-all
  text-overflow ellipsis
  overflow hidden
  white-space nowrap
</style>
